import {type WCPHPData} from '../../../@type/woocommerce/php-data';
import spinnerImageURL from '../../../express-checkout/img/spinner.svg';
import {COMMITHASH} from '../../../git';

declare const peachpay_data: WCPHPData;

function peachpayModalHTMLTemplate() {
	const assetURL = peachpay_data.plugin_asset_url;
	return /* html */ `
<div id="pp-modal-overlay" class="pp-overlay">
	<img src="${peachpay_data.plugin_asset_url}public/dist/${spinnerImageURL}?${COMMITHASH}" id="loading-spinner-iframe" class="pp-spinner-iframe hide">
	<iframe id="peachpay-iframe" src="${assetURL}public/dist/index.html?${COMMITHASH}">
		Unable to load PeachPay Checkout
	</iframe>
</div>
`;
}

export {
	peachpayModalHTMLTemplate,
};
